// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "bundle." + {"148":"0e7bbe86976c740ee20e","367":"4c4f04381166cf114131","642":"28e8e97642fe187de011","978":"53e176e80af3401b77e8"}[chunkId] + ".js";
};